import { render, staticRenderFns } from "./ModalSubPatient.vue?vue&type=template&id=01195222"
import script from "./ModalSubPatient.vue?vue&type=script&lang=js"
export * from "./ModalSubPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports